import { JSX } from "react/jsx-runtime";
import { useEffect, useState } from "react";

import Card from "./Card";
import CardMore from "./CardMore";
import styles from "./Card.module.css";
import { getUseCases, UseCase } from "../../api";
import {
  LOADING_TEXT,
  WORKFLOW_CARDS_INCENTIVE,
  WORKFLOW_CARDS_TITLE,
} from "./constants";

interface CardGroupProps {
  isAssistantAPILoading?: boolean;
  onCardClick: (
    title: string,
    key: string,
    confirmationMessage?: string,
  ) => void;
}

const CardGroup: React.FC<CardGroupProps> = ({
  isAssistantAPILoading,
  onCardClick,
}) => {
  const [useCases, setUseCases] = useState<UseCase[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUseCases = async () => {
      try {
        const useCases = await getUseCases();
        setUseCases(useCases);
      } catch (error) {
        console.error("Error fetching use cases:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUseCases();
  }, []);

  const cards: JSX.Element[] = [];
  useCases.forEach((useCase, index) => {
    if (useCase.id !== "default") {
      cards.push(<Card key={index} onClick={onCardClick} useCase={useCase} />);
    }
  });

  if (isAssistantAPILoading) return null;

  return isLoading ? (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingIcon}></div>
      <p>{LOADING_TEXT}</p>
    </div>
  ) : (
    <div className={styles.cardGroup}>
      <div className={styles.cardGroup1stLine}>{WORKFLOW_CARDS_TITLE}</div>
      <div className={styles.cardGroup2ndLine}>{WORKFLOW_CARDS_INCENTIVE}</div>
      {cards}
      <CardMore/>
    </div>
  );
};

export default CardGroup;
